module.exports = __webpack_public_path__ + "static/Children-c2ab44bdbdfd5fa5aa69979c4d4bd3cb.png";